
import { defineComponent, computed, onMounted, watch, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import TopBarCallToAction from "@/widgets/call-to-action/topbar.vue";
import KTAside from "@/layout/aside/Aside.vue";
import KTHeader from "@/layout/header/Header.vue";
import KTFooter from "@/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTUserMenu from "@/layout/header/partials/ActivityDrawer.vue";
import KTLoader from "@/components/Loader.vue";
import KTCreateApp from "@/components/modals/wizards/CreateAppModal.vue";
import KTNewSite from "@/components/modals/new-site.vue";
import KTSelectPlan from "@/components/modals/select-plan-new/index.vue";
import KTUpgradePlan from "@/components/modals/upgrade-plan/index.vue";
import KTTrialExpired from "@/components/modals/trial-expired.vue";
import KTWelcome from "@/components/modals/welcome.vue";
// import KTExplore from "@/layout/extras/Explore.vue";
import KTDrawerMessenger from "@/layout/extras/DrawerMessenger.vue";
import { Actions } from "@/store/enums/StoreEnums";
import {
  MenuComponent,
  DrawerComponent,
  ScrollComponent,
} from "@/assets/ts/components/index";
import { removeModalBackdrop } from "@/core/helpers/dom";
import { Modal } from "bootstrap";
import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from "@/core/helpers/config";

export default defineComponent({
  name: "Layout",
  components: {
    TopBarCallToAction,
    KTAside,
    KTHeader,
    KTFooter,
    KTToolbar,
    KTScrollTop,
    KTCreateApp,
    KTNewSite,
    KTWelcome,
    KTUserMenu,
    KTSelectPlan,
    // KTExplore,
    KTDrawerMessenger,
    KTLoader,
    KTUpgradePlan,
    KTTrialExpired,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const callToAction = ref({
      text: "O teste gratuito do <b>Enterprise</b> termina em <b>10 dias</b>.",
      action: {
        label: "Ir para Planos",
        url: "plans",
      },
    });

    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });
    const modals = () => {
      if (
        route.path != "/plans" &&
        store.getters.currentUser.plan._id === "62eb089f4458db40f3ba34ee"
      ) {
        const modal = new Modal(
          document.getElementById("kt_modal_trial_expired")
        );
        modal.show();
      } else {
        if (route.hash === "#welcome") {
          const modal = new Modal(
            document.getElementById("kt_modal_welcome"),
            {}
          );
          modal.show();
        }
      }

      removeModalBackdrop();
    };

    onMounted(() => {
      //check if current user is authenticated
      if (!store.getters.isUserAuthenticated) {
        router.push({ name: "login" });
      }

      DrawerComponent.bootstrap();
      ScrollComponent.bootstrap();
      DrawerComponent.updateAll();
      ScrollComponent.updateAll();

      // Simulate the delay page loading
      setTimeout(() => {
        modals();
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);

        DrawerComponent.hideAll();
        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({ name: "login" });
          return;
        }
        modals();
      }
    );

    return {
      modals,
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      themeLightLogo,
      themeDarkLogo,
      callToAction,
    };
  },
});
